import React from 'react'
import IconButtonUI from '../../../widgets/action/IconButtonUI'
import SuperUserAccountPageUI from '../../../templates/SuperUserAccountPageUI.js'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'
import AccountDetailSF from '../../../components/superUser/account/AccountDetailSF'
import KYCNavUI from '../../../components/superUser/account/KYCNavUI.js'

const KYCPageUI = ({ context, account,
  onRefreshClick, copyToClipboardText, onCopyToClipboard,
}) =>
  <SuperUserAccountPageUI context={context} className='pg_su_acc' backLink='/su/accounts'
    headerText={`${account ? account.accountName : ''}`} dimension='w768'
    centered={!account} account={account} page='kyc'
  >
    {
      !account &&
      <SpinnerComponentUI />
    }

    {
      account &&
      <div>
        <ActionLeftUI context={context} onRefreshClick={onRefreshClick} />
        <KYCNavUI account={account} page='company' />
        <AccountDetailSF
          context={context}
          account={account}
          copyToClipboardText={copyToClipboardText}
          onCopyToClipboard={onCopyToClipboard}
          onRefreshClick={onRefreshClick}
        />
      </div>
    }

  </SuperUserAccountPageUI>

const ActionLeftUI = ({ onRefreshClick }) =>
  <div className='g_flex_h g_flex_left'>
    <IconButtonUI icon='icon-refresh' onClick={onRefreshClick} />
    <span className='g_m_left_100 g_large'><b>Know Your Customer</b></span>
  </div>

export default KYCPageUI
